import { useEffect } from 'react'

export function useClickOutside(
  isVisible: boolean,
  containerRef: React.RefObject<HTMLDivElement>,
  selectRef: React.RefObject<HTMLDivElement>,
  onClickOutside: (clickedElement?: HTMLElement) => void
) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!isVisible) return

      const target = event.target as Node
      const clickedElement = event.target as HTMLElement

      if (
        (containerRef.current && containerRef.current.contains(target)) ||
        (selectRef.current && selectRef.current.contains(target))
      ) {
        return
      }

      onClickOutside(clickedElement)
    }

    if (isVisible) {
      const timeoutId = setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside, true)
      }, 0)

      return () => {
        clearTimeout(timeoutId)
        document.removeEventListener('mousedown', handleClickOutside, true)
      }
    }
  }, [isVisible, onClickOutside, containerRef, selectRef])
}
